module.exports = function() {
  return new Worker(__webpack_public_path__ + "0120a379f1b30139eb14.worker.js");
};